import { abmelden as msalAbmelden } from './accessToken';
import { istEntwicklungsLogin, setzeEntwicklungsBenutzer } from './entwicklungsLogin';

/** Abmelden – per MSAL (Produktion) bzw. Entwicklungs-Benutzer vergessen (lokal). */
export async function abmelden(): Promise<void> {
  if (istEntwicklungsLogin) {
    setzeEntwicklungsBenutzer(undefined);
    window.location.assign('/');
    return;
  }
  await msalAbmelden();
}
